import React, { ChangeEvent } from "react";
import { toast } from "react-toastify";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { AccountType, Continue } from "../../../../../../../constants";
import { ActiveCallbackProp } from "../../../../../../../types/Forms";
import { SelectAccountTypeData } from "../../../../../../../data/formsAndTable/forms/FormLayout";
import { useForm } from "react-hook-form";

const ChooseAccount: React.FC<ActiveCallbackProp> = ({ activeCallBack }) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<{ accountType: string }>({});

  const selectedAccount = watch("accountType");

  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    setValue("accountType", value, { shouldValidate: true, shouldDirty: true });
  };

  const handleNextButton = handleSubmit(
    () => {
      if (selectedAccount) {
        activeCallBack(2);
      }
    },
    () => {
      toast.error("Please fill out all the fields before moving on to the next step");
    }
  );

  return (
    <Form className="needs-validation" noValidate onSubmit={(event) => event.preventDefault()}>
      <Row className="g-3">
        <Col xs="12">
          <h5>{AccountType}</h5>
          <p>{"It has long been known that distracting information on a page will lose a reader's attention."}</p>
        </Col>
        <Col xs="12">
          <FormGroup check className="radio radio-primary ps-0 select-account">
            <ul className="radio-wrapper">
              {SelectAccountTypeData.map((data, index) => (
                <li key={index}>
                  <Input id={data.title} type="radio" {...register("accountType", { required: "Please select an account type" })} value={data.title} onChange={updateFormData} />
                  <Label className="mb-0" htmlFor={data.title} check>
                    <i className={`fa fa-${data.icon}`} />
                    <span className="d-flex flex-column">
                      <span>{data.title}</span>
                      <span>
                        {"Search your "}
                        {data.title}
                        {" information please check it"}
                      </span>
                    </span>
                  </Label>
                </li>
              ))}
            </ul>
            {errors.accountType && <span className="text-danger">{errors.accountType.message}</span>}
          </FormGroup>
        </Col>
        <Col xs="12" className="text-end">
          <Button onClick={handleNextButton} color="primary">
            {Continue}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};
export default ChooseAccount;
